export default __webpack_public_path__ + "static/media/red.97e46f71.svg";